import React from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';
import Button from '../components/output/Button';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import './Navigation.css';

const getNavigationStatus = (props, locale) => {
  const { count, maxResults, startPosition } = props;
  const totalPages = parseInt((count - 1) / maxResults, 10) + 1;
  const page = parseInt(startPosition / maxResults, 10) + 1;
  return page + ' ' + getLabel(locale, 'general.of') + ' ' + totalPages;
};

const navigate = (e, direction, { maxResults, startPosition, handleNavigation }) => {
  handleNavigation({ target: { name: 'startPosition', value: startPosition + maxResults * direction } }, true);
};

const LeftNavigationButton = props => {
  if (props.startPosition - props.maxResults < 0) {
    return <span className="left-nav"></span>;
  }

  if (props.isLoading) {
    return (
      <span className="left-nav">
        <Button disabled="disabled">
          <ChevronLeft size={16} />
        </Button>
      </span>
    );
  }

  return (
    <span className="left-nav">
      <Button onClick={(e) => navigate(e, -1, props)}>
        <ChevronLeft size={16} />
      </Button>
    </span>
  );
};

const RightNavigationButton = props => {
  if (props.startPosition + props.maxResults >= props.count) {
    return <span className="right-nav"></span>;
  }

  if (props.isLoading) {
    return (
      <span className="right-nav">
        <Button disabled="disabled">
          <ChevronRight size={16} />
        </Button>
      </span>
    );
  }

  return (
    <span className="right-nav">
      <Button onClick={(e) => navigate(e, 1, props)}>
        <ChevronRight size={16} />
      </Button>
    </span>
  );
};

const Navigation = (props, context) => (
  <div className="Navigation">
    <LeftNavigationButton {...props} />
    <span className="results">{getNavigationStatus(props, context.locale)}</span>
    <RightNavigationButton {...props} />
  </div>
);

Navigation.contextTypes = {
  locale: PropTypes.string,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/main/cruds/Navigation.js